import 'slick-carousel'

require('metrojs')

import { select2 } from 'select2';

import Alpine from 'alpinejs'

import intersect from '@alpinejs/intersect'


import 'lightbox2/dist/css/lightbox.min.css'

import lightbox from 'lightbox2'

import AOS from 'aos'



Alpine.plugin(intersect)

window.Alpine = Alpine

Alpine.start()

AOS.init({
    once: true,
})

window.addEventListener('load', function() {
  AOS.refresh();
  setTimeout(() => {
    AOS.refresh();
  }, 500); 
});

// Refresh AOS on page show (essential for bfcache/back-button navigation)
window.addEventListener('pageshow', function(event) {
    if (event.persisted) {
        AOS.refresh();
    }
});

lightbox.option({
    'showImageNumberLabel': false
})

var previousScroll = 0;

$(window).scroll(function(){
    var currentScroll = $(this).scrollTop();
    if ($(window).scrollTop() > 50 && currentScroll > 0 && currentScroll < $(document).height() - $(window).height()){
        var showDropdownExist = $('.dropdown-menu.show').length;
        // if (currentScroll > previousScroll && !showDropdownExist) window.setTimeout(hideNav, 300);
        // else window.setTimeout(showNav, 300);
        previousScroll = currentScroll;
    }
    // if ($(window).scrollTop() > 28 && !showDropdownExist){
    if ($(window).scrollTop() > 28){
        if($(window).width() < 992 && showDropdownExist)  {
            // $('.main-navigation').css('position', 'relative')
            // // $('.hero-section').css('margin-top', 0);
        }else{
            $('.main-navigation').css('position', 'fixed');
            $('.hero-section').css('margin-top', 70);
        }
    }
    else {
        $('.main-navigation').css('position', 'relative')
        $('.hero-section').css('margin-top', 0);
    };
});

function hideNav() {
    $(".main-navigation").removeClass("is-visible").addClass("is-hidden");
}
function showNav() {
    $(".main-navigation").removeClass("is-hidden").addClass("is-visible");
}

var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new bootstrap.Tooltip(tooltipTriggerEl)
})

$(".copy-clipboard").mouseover(function() {
    $(this)
      .attr('data-bs-original-title', 'Click to Copy')
      .tooltip('show');
  });
  var $temp = $("<input>");
  $('body').on('click', '.copy-clipboard', function(e) {
    e.preventDefault();
    var $url = $(this).data('url');
    $("body").append($temp);
    $temp.val($url).select();
    document.execCommand("copy");
    $temp.remove();
    $(this)
      .attr('data-bs-original-title', 'Copied')
      .tooltip('show');
  });

  $(".live-tile, .flip-list").liveTile();

  import SimpleLightbox from "simplelightbox";

  var $gallery;
    (function() {
        $gallery = new SimpleLightbox('.lighbox-upcoming-gallery a.popup-image', {
            overlayOpacity : 0.5,
        });
    })();

    function setcookie(cookieName){
        var now = new Date();
        var time = now.getTime();
        time += 3600*1000*24;
        now.setTime(time);
        document.cookie =
        cookieName+ '; expires=' + now.toUTCString() + '; path=/';
    };
    function getCookie(cookieName) {
        return document.cookie.indexOf(cookieName);
    }
    var cookie = getCookie('popupBatchgallery');
    if(cookie == -1){
        setcookie('popupBatchgallery');
        setTimeout(() => {
            $('.event-popup').modal('show');
        }, 1500);
    }

    $(".query-goto").click(function(e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $(".enquiry-section").offset().top
        }, 100);
        $('.nav-tabs #nav-profile-tab').tab('show')
    });

    let moveUpButton = document.getElementById("moveUp");
    window.onscroll = function() {scrollFunction()};

    function scrollFunction() {
        if (document.body.scrollTop > 60 || document.documentElement.scrollTop > 60) {
            moveUpButton.style.display = "block";
        } else {
            moveUpButton.style.display = "none";
        }
    }
